import React from "react";
import {
    Text,
    StyleSheet,
} from "@react-pdf/renderer";
import {PdfElementProps} from "./_models";

export function PdfTextComponent({config}: PdfElementProps) {
    const style = StyleSheet.create({
        main: {
            ...{
                fontSize: '11pt',
                color: '#000000',
                paddingRight: '40px',
            },
            ...(config.style || {}),
        }
    })

    return (
        <Text style={style.main}>{config.content}</Text>
    )
}